module.exports = process.env.NODE_ENV === 'production' ? require('./build/mocks') : require('./build');

//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-prop-types/index.js
// module id = 482
// module chunks = 0